/**
 * Valida que una prop requerida no sea null o undefined
 * @param value
 * @param propName
 * @param componentName
 * @throws
 */
export const validateRequiredProp = <T>(
  value: T,
  propName: string,
  componentName: string,
): void => {
  if (value === null || value === undefined) {
    throw new Error(
      `${componentName} component requires a valid ${propName} prop. ${propName} cannot be null or undefined.`,
    );
  }
};

/**
 * Valida que una prop requerida no sea un string vacío
 * @param value
 * @param propName
 * @param componentName
 * @throws
 */
export const validateNonEmptyString = (
  value: string | null | undefined,
  propName: string,
  componentName: string,
): void => {
  if (value === null || value === undefined || value.trim() === '') {
    throw new Error(
      `${componentName} component requires a non-empty ${propName} prop. ${propName} cannot be null, undefined, or empty.`,
    );
  }
};
